module.exports = __webpack_public_path__ + "img/close.c984c261.svg";